/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationItemSchema } from "./comboCalculationItemSchema.ts";

export const comboCalculationGroupSchema = z.object({
	id: z.uuid(),
	item: comboCalculationItemSchema,
});
